import mainLogo from '../../images/Euroville/euroville_logo_main_black.png';
import squareLogo from '../../images/Euroville/euroville_logo_small_black.png';
import squareLogoCustom from '../../images/Euroville/euroville_logo_small_black.png';
import bannerLogoWhite from '../../images/Euroville/euroville_logo_small_white.png';
import banner01 from '../../images/Euroville/eurovilleBarao_BG_01.jpg';
import banner02 from '../../images/Euroville/eurovilleBarao_BG_02.jpg';
import banner03 from '../../images/Euroville/eurovilleBarao_BG_03.jpg';
import banner04 from '../../images/Euroville/eurovilleBarao_BG_04.jpg';
import car123 from '../../images/Euroville/123_stonic.jpg';
import box123 from '../../images/Euroville/123_stonic.jpg';
import missingPic from '../../images/Euroville/euroville_missingPic.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Kia Euroville',
    defaultStoreLink: 'pecaskia.com.br',
    defaultContactEmail: 'eurovillekiabdg@goparts.com.br',
    whatsappNumber: '31 99358 9358',
    CNPJname: 'BDG EUROVILLE K VEICULOS E PECAS LTDA',
    CNPJ: '59.898.044/0001-23',
    CNPJaddress: 'Logradouro Av Barao Homem de Melo, 3030 - Loja 01 e 02, Belo Horizonte - MG, 30.494-080"',
    launchDate: '14/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "kia",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "EUROVILLE KIA (Barao)",
        "464-EUROVILLE KIA",
    ],
    
    disabledSellers: [
    ],

    useMktNames: true,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Mais buscados',
            img: 'tabAll',
            products: SliderProducts.Kia
        },
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.EurovilleKits
        },
        // {
        //     name: 'Óleos',
        //     img: 'tabOleos',
        //     products: SliderProducts.Oleos
        // },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        // {
        //     name: 'Acessórios',
        //     img: 'tabAcessorios',
        //     products: SliderProducts.Acessorios
        // },
        // {
        //     name: 'Luzes',
        //     img: 'tabLuzes',
        //     products: SliderProducts.Luzes
        // },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,

    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogoCustom,
    paymentImgMobile: squareLogoCustom,

    missingPic: missingPic,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais compatíveis com <span style="font-weight: bold;">seu veículo</span>, direto das concessionárias <span style="font-weight: bold;">Kia Euroville</span>.',
    aboutUs: {
        title: 'Quem Somos',
        content: [
            'KIA Euroville a maior e mais moderna concessionária da marca do país. Faz parte do grupo BDG o Brasil Dealer Group, com mais de 30 anos de experiencia no setor automotivo.',
            'A Mega Store esta localizada na Avenida Barão Homem de Melo, com infraestrutura ampla e moderna, buscando melhorar a prestação de serviços e o alto padrão de atendimento aos clientes KIA em Minas Gerais.',
            'A KIA Euroville conta com amplo showroom de novos e seminovos , além do moderno centro de serviços KIA. Com oficina completa, equipe qualificada e equipamentos de última geração.',
        ],
        link: 'https://kiabarao.com.br/sobre',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/kiaeuroville/',
        Facebook: 'https://www.facebook.com/kiaeuroville/',
        LinkedIn: 'https://www.linkedin.com/company/kia-euroville/about/?viewAsMember=true',
        Youtube: 'https://www.youtube.com/channel/UCFcCLtVCvvCRi7_Dl2zZ6Ug',
        Twitter: '',
    },

    footerContent: [],
}